import React from 'react';
import { Box, } from '@waglabs/box-next';
export const Image = ({ srcSet, ...rest }) => (React.createElement(Box, Object.assign({ as: "img", srcSet: srcSet }, rest)));
